import { config } from "@noted/configuration";

const isDevelopment = () => import.meta.env.MODE === "development";

// Dev-only escape hatch: lets a local .env.local point Noted admin users at a
// different port to test the replacement dark-noted app without having to edit
// the shared @noted/configuration package.
export const darkNotedUrl =
  (isDevelopment() && import.meta.env.VITE_DARK_NOTED_URL) || config.darkNotedUrl;
